var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewComparisonSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_209_4",
    "data-name": "Component 209 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15221",
    "data-name": "Group 15221",
    transform: "translate(-212.141 -2984.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11475",
    "data-name": "Group 11475",
    transform: "translate(219.141 2989.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3654",
    "data-name": "Rectangle 3654",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.048,
    height: 18.965,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 14.548,
    height: 17.465,
    rx: 0.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11990",
    "data-name": "Path 11990",
    d: "M-1784.341,19365.236h3.484v16.875h-13.619v-3.459",
    transform: "translate(2018.758 -16371.112)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14647",
    "data-name": "Path 14647",
    d: "M-8289.851,4296.109l2.044,2.074,4.688-5.013",
    transform: "translate(8513.654 -1296.218)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7569",
    "data-name": "Rectangle 7569",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewComparisonSheet);
export default __webpack_public_path__ + "static/media/ViewComparisonSheet.3ecce32de84212392ce1a208191e350f.svg";
export { ForwardRef as ReactComponent };